import { StakingData } from '../web3/model/staking.model';

export type RoundTypeResponse = 'PUBLIC' | 'PRIVATE';
export type RoundStakingStatus = 'ON' | 'OFF' | 'CANCELED' | 'ENDED';

export type StakingType =
    'AUTOMATIC' | // value = 0
    'MANUAL' // value = 1

export const toRoundType = (roundType: BigInt): RoundTypeResponse => {
    switch (Number(roundType)) {
        case 0:
            return 'PUBLIC';
        case 1:
            return 'PRIVATE';
    }
    throw new Error('Invalid round type');
};
export const toRoundStatus = (roundStatus: BigInt): RoundStakingStatus => {
    switch (Number(roundStatus)) {
        case 0:
            return 'ON';
        case 1:
            return 'OFF';
        case 2:
            return 'CANCELED';
        case 3:
            return 'ENDED';
    }
    throw new Error('Invalid round status');
};

export const toRoundStatusNumber = (roundStatus: RoundStakingStatus): BigInt => {
    switch (roundStatus) {
        case 'ON':
            return BigInt(0);
        case 'OFF':
            return BigInt(1);
        case 'CANCELED':
            return BigInt(2);
        case 'ENDED':
            return BigInt(3);
    }
    throw new Error('Invalid round status');
};

export const toStakingTypeNumber = (stakingType: StakingType): BigInt => {
    switch (stakingType) {
        case 'AUTOMATIC':
            return BigInt(0);
        case 'MANUAL':
            return BigInt(1);
    }
    throw new Error('Invalid staking type');
}

export const toStakingType = (stakingType: number): StakingType => {
    switch (Number(stakingType)) {
        case 0:
            return 'AUTOMATIC';
        case 1:
            return 'MANUAL';
    }
    throw new Error('Invalid staking type');
}


export type SaleRound = {
    roundId: string;
    roundStatus: RoundStakingStatus;
    roundType: RoundTypeResponse;
    allocation: string;
    isPublic: boolean;
    isStackable: boolean;
    tokenPrice: string;
};

export type StackingTypeResponse = 'FIXED' | 'FLEXIBLE';
export const toStackingType = (stackingType: BigInt): StackingTypeResponse => {
    switch (Number(stackingType)) {
        case 0:
            return 'FIXED';
        case 1:
            return 'FLEXIBLE';
    }
    throw new Error('Invalid stacking type');
};

export type StackingRoundResponse = {
    stackingId: string;
    stackingStatus: RoundStakingStatus;
    tokensAvailable: number;
    stackingType: StackingTypeResponse;
    cliffPeriod: number;
    vestingPeriod: number;
    endStacking: string;
    stackingRewardPercentage: number;
    createdAt: string;
};

export type UserStake = {
    amount: number;
    createdAt: number;
};


export type StakingInfo = {
    stakingId: string;
    stakingDetails: StakingData;
}
